import moment from 'moment';
import { addDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { EMPTY_INPUT, FABRIC_PRODUCTION_TYPE, FACTORS, MAX_COMPOSITION_PERCENTAGE, REQUIREMENT_TYPE } from 'src/constants';
import { PRODUCTION_SUB_TYPE } from 'src/constants/quoute';
import { pick, round } from 'lodash';
import { POLYESTER_LABEL } from 'src/components/PolyesterRequestForm/config';
import { CreditChargeItem } from './interfaces';
import { SPECIMEN_TYPE } from 'src/components/QuoteDetailsCard';
const isInternational=localStorage.getItem('isInternational')==='1';

export const DEFAULT_TRUNCATE_LENGTH = 10;

export const nounWord = (word: string, count: string | number | Number, addedString: string = 's' ): string => {
  if(word === 'All open'){
    return word
  }
  return count <= 1 ? word : `${word}${addedString}`;
};

export const capsFirstLetter = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const formatNumWithCommas = (x?: string | number): string => {
  if (x === undefined) return '';
  const value = x.toString();
  const cleanedValue = value.replace(/\.0+$/, '');
  if (!cleanedValue.includes('.')) {
    return cleanedValue.replace( /\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',' );
  }
  const [integerPart, decimalPart] = cleanedValue.split('.');
  const formattedInteger = integerPart.replace( /\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',' );
  return `${formattedInteger}.${decimalPart}`;
};

export const parseNumFromCommas = (x?: string | number): string => {
  if (x === undefined || x === null) return '';
  return x.toString().replace(/,/g, '');
};

export const DATE_MMMDDYYYYY = (date?: string): string => {
  return date === undefined ? '' : moment(date).format('ll');
};

export const DATE_MMYYYYY = (date?: string): string => {
  return date === undefined ? '' : moment(date).format('DD MMM, YYYY');
};

export const TIME_HHMM_AA = (date?: string): string => {
  return date ? moment(date).format('LT') : '';
};

interface getLinkTypes {
  id?: number;
  title?: string;
  name?: string;
  url?: string;
  isFinalDispatch?: boolean;
  dispatchNumber?: number;
}

export const getLink = (
  finder: string,
  arr?: Array<{ title: string; url: string }>
): getLinkTypes | undefined => {
  return arr
    ?.filter((data) => {
      return data.title === finder;
    })
    .pop();
};

export const orderValueCalc = (
  quantity: string,
  quotedUnitPrice: string,
  taxPercentage: string
): string =>
  (
    Number(quantity) * Number( isInternational ?Number(quotedUnitPrice).toFixed(2):quotedUnitPrice) +
    Number(quantity) * Number(quotedUnitPrice) * (parseFloat(taxPercentage) / 100)
  ).toFixed(2);

export const gstPattern = (gstNumber: string): string => {
  return `${gstNumber.slice(0, 2)} ${gstNumber.slice(2, 12)} ${gstNumber.slice(12, 15)}`;
};

export const phoneNumberPattern = (phoneNumber: string): string => {
  return `${phoneNumber.slice(0, 9)} ${phoneNumber.slice(9, 14)}`;
};

export const capsAll = (word: string): string => {
  return word.toUpperCase();
};

export const calcExpiry = (createdOn: string, quoteValidity: number): boolean | string => {
  const date = new Date(createdOn);

  const expiryDate = new Date(new Date(addDays(date, quoteValidity)).setHours(23, 59, 59, 999));

  if (expiryDate <= new Date()) return 'expired';

  const differenceInHour = differenceInHours(expiryDate, new Date());
  if (differenceInHour > 48) return false;
  if (differenceInHour === 1) return `${differenceInHour} hr`;
  if (differenceInHour <= 48 && differenceInHour !== 0) return `${differenceInHour} hrs`;

  const differenceInMins = differenceInMinutes(expiryDate, new Date());
  if (differenceInMins === 1) return `${differenceInMins} min`;
  if (differenceInMins > 1) return `${differenceInMins} mins`;

  return false;
};

export const handleEmptyInput = (inputValue: string): string => {
  return inputValue || EMPTY_INPUT;
};

export const isWebView = !!(window as any).ReactNativeWebView;
export const sendAppLinkEvent = (event: string): void => {
  if (isWebView) {
    (window as any).ReactNativeWebView.postMessage(JSON.stringify({ eventType: event }));
  }
};
export const checkFileType = (fileName: string, fileType: string): boolean => {
  if (fileName.split('.').pop() === fileType) {
    return true;
  } else {
    return false;
  }
};
export const splitIntoChunk = (arr: Array<Object>): Array<Object> => {
  let ans = [];
  for (let i = 0; i < arr.length; i += 2) {
    let tempArray;
    tempArray = arr.slice(i, i + 2);

    ans.push(tempArray);
  }
  return ans;
};
export const requestLinkUrl = (path: String, data: any): string => {
  let link = path ? path + '/?' : '';
  let newData = Object.keys(data);
  newData.map((key, index) => {
    link += `${key}=${data[key]}${index === newData.length - 1 ? '' : '&'}`;
  });
  return link;
};

export const getDifferenceMinutes = (QualityRefreshedTime?: string | null): number =>
  moment().diff(moment(QualityRefreshedTime), 'minute');
export const getCurrentIsoString = (): string => moment().toISOString();

export const objectCleaner = (obj:any) => { 
  for (const [key,value] of Object.entries(obj)) {
    if (!value) {
      delete obj[key];
    }
  }
  return obj;
}

export const __weavingQueries = (productionSubType:any) => {
  if(productionSubType === PRODUCTION_SUB_TYPE.Greige || productionSubType === PRODUCTION_SUB_TYPE.YarnDyed){
    return true;
  } 
  return false;
}

export const __computeFabricCost = (quantity:number,quotedUnitPrice:number,logisticsCost:number): number => {
  return round(quantity * (quotedUnitPrice - logisticsCost), 2);
}

export const __computeConstructionAndThreadCount = (val1:string,val2:string): string => {
  return val1 ? `${val1} x ${val2}` : '--'
}

export const __getCurrencySymbol = (isInternational?:Number):string => {
  if(isInternational){
    return '$'
  }
  return ' ₹'
}
export const __getUnit = (isInternational?: Number): string => (isInternational ? 'yd' : 'm');

export const blurOnScroll = (event: any) => event.target.blur();

export const __bankDetailsLabel = (isInternational?: Number): string =>
  isInternational ? 'Swift code' : 'IFSC code';

export const __getBankDetailsCode = (
  isInternational: Number,
  swiftCode: string,
  ifsc: string,
): string => (isInternational ? swiftCode : ifsc);

export const __supplierUnitPriceVisible = (
  isInternational?: Number,
  price?: Number,
  tat?: Number,
  supplierId?: Number,
) => {
  return price ? (isInternational && tat && supplierId) || !isInternational : false;
};
export const certificationTransformer = (certification: any) => {
  const obj:{[key: number]: string} = {};
  certification.map((val: {value: number, label: string}) => {
    obj[val.value] = val.label;
    return null;
  });
  return obj;
};

export const subCategoryTransformer = (data: any) => {
  const excludedValues: number[] = JSON.parse(process.env.REACT_APP_EXCLUDED_LINEN_VALUES || '[]');
  
  const transformedData = Object.fromEntries(
    Object.entries(data).map(([key, array]) => [
      key,
      Array.isArray(array) 
        ? array.filter((item) => !excludedValues.includes(item.value))
        : array,
    ]),
  );

  return transformedData;
};

export const subCategoryTransformerForDenim = (data: any) => {
  const transformedData = subCategoryTransformer(data.fabricSubCategory);
  return { ...data, fabricSubCategory: transformedData };
};

export const checkValidFormValidations = (values: {}, keysToBeValidated: string[]): boolean => {
  const picked: any = pick(values, keysToBeValidated);
  return !(Object.keys(picked).length > 0);
};

export const checkValidComposition = (obj: any, isCottonCase: boolean, isDenimCase: boolean) => {
  let totalSum = 0;
  const maxPercentage = Number(obj[0].percentage);
  const maxCategoryLabel = obj[0].label;
  for (let i = 0; i < obj.length; i++) {
    if (
      !obj[i].categoryId ||
      !obj[i].percentage ||
      (obj[i].percentage && +obj[i].percentage <= 0)
    ) {
      return { isValid: false };
    }
    totalSum += Number(obj[i].percentage);
    if (totalSum > 100) {
      return { isValid: false, isGreater: true };
    }
  }

  if (totalSum > 100) {
    return { isValid: false, isGreater: true };
  }

  if (totalSum < 100) {
    return { isValid: false, isLesser: true };
  }
  if (totalSum !== 100) {
    return { isValid: false };
  }
  if (totalSum === 100 && isDenimCase) {
    return { isValid: true };
  }

  if (isCottonCase) {
    if (
      (maxCategoryLabel === 'Cotton' || maxCategoryLabel === POLYESTER_LABEL) &&
      maxPercentage >= MAX_COMPOSITION_PERCENTAGE
    ) {
      return { isValid: true };
    } else {
      return { isValid: false };
    }
  } else {
    if (maxCategoryLabel === 'Viscose' && maxPercentage >= MAX_COMPOSITION_PERCENTAGE) {
      return { isValid: true };
    } else {
      return { isValid: false };
    }
  }
};
export const requirementTypeValue = (
  productionType: number,
  productionSubType: number,
  overRideRequirementTypeText?: string,
): string => {
  const isFinishedFabric = productionType === FABRIC_PRODUCTION_TYPE.FINISHED_FABRIC;
  return `${isFinishedFabric ? 'Finished fabric -' : ''} ${
    overRideRequirementTypeText || REQUIREMENT_TYPE[productionSubType]
  }`;
};

export const removeCharacter = (str = '', chr = '') => (!str ? '' : String(str).replace(chr, '').trim());
export const checkIfSCCertificateRequied = (values: string[] = []) => {
  const certifications = ['OCS-Organic', 'GOTS-Organic', 'Organic 100', 'Organic'];
  return certifications.some((cert) => values?.includes(cert));
};

export const specificCertifications = [
  'BCI',
  'Oeko-Tex',
  'OCS-Organic',
  'GOTS-Organic',
  'Organic 100',
  'Organic',
];
export const convertToInternational = (quantityInMeters:any) => {
  return parseFloat(quantityInMeters) * FACTORS.METER_TO_YARD;
};

export const roundOffTo05 = (value: number) => {
  if (value == null || isNaN(value)) return value;
  const result = Math.ceil(value / 0.05) * 0.05;
  return Number(result.toFixed(2));
}

const toNumber = (value: unknown): number | undefined => {
  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
};

const getCreditCharges = (
  creditChargesMap: CreditChargeItem[] = [],
  creditPeriod?: number | string | null,
): number => {
  const period = toNumber(creditPeriod);
  if (period === undefined) return 0;

  const match = creditChargesMap.find(
    item => toNumber(item?.creditPeriod) === period,
  );

  return toNumber(match?.creditCharges) ?? 0;
};

export const replaceUrlParamsWithFilteredData = (
  url: string,
  data: Record<string, any>,
): string => {
  const [path, queryString] = url.split('?');

  if (!queryString) return url;

  const params = new URLSearchParams(queryString);
  const hasCreditChargesParam = params.has('creditCharges');
  const creditPeriod = params.has('creditPeriod') ? params.get('creditPeriod') : 0;

  const creditCharges = hasCreditChargesParam
    ? getCreditCharges(data?.creditChargesMap, creditPeriod)
    : undefined;

  const valueResolvers: Record<string, () => unknown> = {
    supplierLocation: () =>
      data?.supplierLocation ?? data?.supplierAddress?.city,
    creditCharges: () => creditCharges,
    fabricCost: () => data?.totalQuotePrice,
    liveRateQuoteId: () => toNumber(data?.id),
  };

  params.forEach((_, key) => {
    const resolver = valueResolvers[key];
    const value = resolver ? resolver() : data?.[key];

    if (value === undefined || value === null) return;

    params.set(
      key,
      typeof value === 'string' || typeof value === 'number'
        ? String(value)
        : JSON.stringify(value),
    );
  });

  return `${path}?${params.toString()}`;
};

export const truncateString = (
  input: any,
  maxLength: number = DEFAULT_TRUNCATE_LENGTH
): string => {
  const safeString = String(input ?? '');
  if (safeString.length <= maxLength) return safeString;
  return `${safeString.slice(0, maxLength)}...`;
};

export const maskPhone = (phone?: string) => {
  if (!phone) return '';
  // keeps last 4 digits
  return phone.replace(/\d(?=\d{4})/g, '*');
};

export const maskEmail = (email?: string) => {
  if (!email) return '';

  const [name, domain] = email.split('@');
  if (!domain) return email;

  const visibleLength = Math.ceil(name.length / 2);
  const maskedLength = name.length - visibleLength;

  return `${name.slice(0, visibleLength)}${'*'.repeat(maskedLength)}@${domain}`;
};

export const __getSpecimenLabel = (specimenType: number) => {
  if (specimenType === SPECIMEN_TYPE['SAMPLE']) {
    return 'Request yardage';
  }
  return 'Request hanger';
};

export const formatNumberString = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '';

  const num = Number(value);

  if (isNaN(num)) return String(value);

  return num.toString();
};